import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";

import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@mui/material";
import axios from "axios";
import { Dimmer } from "../components/spinner";

const CatalogoCoordinacion = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const txtBuscador = useRef();
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({}); // Para guardar la selección temporal
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [itemSelect, setItemSelect] = useState(-1); // Índice de la fila seleccionada
  const [activo, setActivo] = useState(true); // Controla el botón Aceptar

  // Se eliminó la columna 'accion' del headCells
  const headCells = [
    {
      id: "idcoordinacion",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombre",
      label: "DESCRIPCIÓN",
      width: "300px",
      textAlign: "left",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idcoordinacion.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  // Lógica al hacer clic en una fila
  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false); // Habilita el botón Aceptar

    const selectedRecord = recordsAfterPagingAndSorting()[index];

    var idcor = selectedRecord.idcoordinacion;
    var nom =
      selectedRecord.nombre.trim() +
      "(" +
      selectedRecord.nombredir.trim() +
      ")";

    // Guardamos los datos en un array para seguir el patrón de CatalogoProveedor
    var datos = [];
    datos.push({
      idcor,
      nom,
    });

    setValues(datos);
  };

  // Lógica al presionar el botón Aceptar del Footer
  const seleccionarLista = () => {
    blanquear();
    // Pasamos los datos usando el índice 0 del array 'values'
    props.onHideAceptaCatCord(values[0].idcor, values[0].nom);
  };

  const seleccionarCoordinacion = () => {
    let endpoint = `${op.conexion}/api/catalogo/coordinacion?idefiscal=${idefiscal}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var cord = [];
          for (let i = 0; i < response.data.length; i++) {
            cord.push({
              idcoordinacion: response.data[i].idcoordinacion,
              nombre: response.data[i].nombre,
              nombredir: response.data[i].nombredir,
            });
          }
          setRecords(cord);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    // Resetear estados de selección
    setItemSelect(-1);
    setActivo(true);
    setValues({});
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatCord();
  };

  // Se eliminó la función 'seleccionarCord' anterior ya que la lógica ahora pasa por 'seleccionarLista'

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      keyboard={false}
      onShow={() => {
        seleccionarCoordinacion();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Seleccionar Unidad Solicitante.</h3>
        <a type="button" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>

        <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
          <input
            type="text"
            ref={txtBuscador}
            onChange={handleSearch}
            className="form-control rounded-pill search-input"
            placeholder="Buscar..."
          />
        </div>

        <div className="col-12 p-0 m-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idcoordinacion}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "80px",
                      }}
                    >
                      {item.idcoordinacion}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.nombre + "(" + item.nombredir + ")"}
                    </td>
                    {/* Se eliminó la columna de botones de acción */}
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-success btn-sm rounded-pill fw-bold"
          disabled={activo}
          onClick={seleccionarLista}
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill fw-bold"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoCoordinacion;
